import { WorkloadWeekProps } from './types';
import { getPrefix } from './helpers';
import { shortDate } from '@utils/i18n';
import { useTranslation } from 'react-i18next';
import { cn } from '@utils/cn';
import { addWeeks } from 'date-fns';
import { useWorkloadContext } from '@contexts/workload';
import { getFirstDayOfBusinessWeek, getLastDayOfBusinessWeek } from '@contexts/workload/constants';

export const WorkloadWeek = ({ date }: WorkloadWeekProps) => {
  const { isTwoWeekly } = useWorkloadContext();
  const { t } = useTranslation('app');
  const prefix = getPrefix(date);

  return (
    <div
      className={cn(
        'flex select-none flex-col font-bold',
        isTwoWeekly ? 'justify-center' : 'h-9 justify-end',
      )}>
      {!isTwoWeekly && <span className="text-xs text-neutral-300">{t(prefix)}</span>}
      <span className={cn('text-neutral-500', isTwoWeekly ? 'text-m' : 'text-sm')}>
        {[
          shortDate(getFirstDayOfBusinessWeek(date)),
          shortDate(getLastDayOfBusinessWeek(isTwoWeekly ? addWeeks(date, 1) : date)),
        ].join(' - ')}
      </span>
    </div>
  );
};
